import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';

import ClaimStatus from '../common/ClaimStatus/ClaimStatus';
import ProformaInvoice from './ProformaInvoice/ProformaInvoice';

import Database from '../../Logic/Database';
import Claim from '../../Logic/Claim';

import './ExcessInvoice.css';

class ExcessInvoice extends React.Component {
  constructor(props) {
    super(props);

    this.fetchData = this.fetchData.bind(this);
    this.checkConfirmations = this.checkConfirmations.bind(this);

    this.state = {
      Insured: {},
      Claim: {},
      Outlet: {},
      Vehicle: {},
      Fitment: {},
      invoice: '<p>Loading</p>',
    };
  }

  componentDidMount() {
    this.fetchData();
    this.checkConfirmations();
  }

  async fetchData() {
    try {
      const data = await Database.FetchAllData();
      const allDataConfirmed = await Database.AllDataConfirmed();

      const alertContent = !allDataConfirmed ? (
        <div className="text-left">
          <p>Welcome to the Autoboys Claims App.</p>
          <p>Here you can keep up to date with all your claim activity.</p>
          <p>
            Please confirm your
            {' '}
            <b>Vehicle Detail</b>
            {' '}
            and your
            {' '}
            <b>Fitment Address</b>
            , to ensure we service you correctly.
          </p>
        </div>
      ) : null;

      this.setState({
        Insured: data.Insured,
        Claim: data.Claim,
        Outlet: data.Outlet,
        Vehicle: data.Vehicle,
        Fitment: data.Fitment,
      });

      const invoiceData = await Claim.FetchExcessInvoice(data.Claim.Excess);
      this.setState({ invoice: invoiceData });

      // Show welcome alert if needed
      if (!sessionStorage.getItem('welcomeShown') && alertContent) {
        await Swal.fire({
          title: 'Confirm Details',
          html: renderToStaticMarkup(alertContent),
          icon: 'info',
          confirmButtonText: 'OK',
        });
        sessionStorage.setItem('welcomeShown', true);
      }
    } catch (error) {
      console.error(error);
      this.props.errorOccured(true);
    }
  }

  checkConfirmations() {
    try {
      Database.FetchVehicle((error, vehicle) => {
        if (!error) {
          this.props.confirmVehicle(vehicle.Confirmed);
          Database.FetchFitment((err1, fitment) => {
            if (!err1) {
              this.props.confirmAddress(fitment.Confirmed);
            }
          });
        }
      });
    } catch (error) {
      console.error(error);
      this.props.errorOccured(true);
    }
  }

  render() {
    return (
      <div id="ExcessInvoice" className="row">
        <ClaimStatus />
        <ProformaInvoice
          invoice={this.state.invoice}
          CreateExcessInvoicePDF={Claim.CreateExcessInvoicePDF}
          currentStatus={this.props.currentStatus}
        />
      </div>
    );
  }
}

ExcessInvoice.propTypes = {
  errorOccured: PropTypes.func.isRequired,
  confirmVehicle: PropTypes.func.isRequired,
  confirmAddress: PropTypes.func.isRequired,
  currentStatus: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  currentStatus: state.currentStatus,
});

const mapDispatchToProps = (dispatch) => ({
  confirmVehicle: (confirmed) => { dispatch({ type: 'CONFIRM_VEHICLE', value: confirmed }); },
  confirmAddress: (confirmed) => { dispatch({ type: 'CONFIRM_ADDRESS', value: confirmed }); },
  errorOccured: (hasError) => { dispatch({ type: 'ERROR_OCCURED', value: hasError }); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ExcessInvoice);
